import Header from '../../components/Header';
import OrderStatusCard from '../../components/OrderStatusCard';
import {ReactComponent as LaundryMachineIcon} from '../../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingBoxIcon} from '../../components/svgs/shippingboxicon.svg';


import StatusDropdown from '../../components/StatusDropdown';
import OwnerSidebar from '../../components/owner/OwnerSidebar';
import OwnerOrderTab from '../../components/owner/OwnerOrderTab';

// laundry status data
const laundryStatus = [
  { label: 'All', link: '#' },
  { label: 'Binned', link: '#' },
  { label: 'Washing', link: '#' },
  { label: 'Drying', link: '#' },
  { label: 'Folding', link: '#' },
];

// laundry days data
const laundryDays = [
  { label: 'Today', link: '#' },
  { label: 'Last 7 Days', link: '#' },
  { label: 'Last 14 Days', link: '#' },
  { label: 'Last 30 Days', link: '#' },
  { label: 'All Time', link: '#' },
];


const OwnerOrderScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <OwnerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Orders'} orderSubtitle={'Manage order'} showButton={false} /> 
          <section className='mt-10 flex gap-5'>
            <OrderStatusCard icon={<LaundryMachineIcon/>} noOfOrders={23} noOfOrdersClassName="custom-style" dueDay={"In Laundry"} orderText={'orders'} size={'24'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-20" />} showSizeAndRevenue={false}/>
            <OrderStatusCard icon={<ShippingBoxIcon/>} noOfOrders={19} noOfOrdersClassName="custom-style" dueDay={"Ready for Pickup"} orderText={'orders'} size={'12'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryDays} dropdownText={'Today'} className="status-card-dropdown-today" />} showSizeAndRevenue={false}/>
          </section>
          <section className='mt-20 flex gap-4'>
            <section>
              <OwnerOrderTab />
            </section>
          </section>
        </main>
      </section>

    </>
  )
}
export default OwnerOrderScreen